import React from "react";
import pusparaj from "../resource/pusparaj.png";
import uttam from "../resource/uttam.png";
import Siddharth from "../resource/Siddharth.jpeg";
import wave from "../resource/wave_final.png";
import { FaEye, FaBullseye, FaLightbulb, FaLeaf, FaUsers, FaRocket, FaHandshake, FaChartLine, FaGlobe, FaCogs, FaBrain, FaAward, FaCertificate } from "react-icons/fa";

export const AboutUs = () => {
  const teamMembers = [
    {
      name: "Mr. Purushottam P Singhal",
      role: "Chief Executive Officer",
      image: pusparaj,
      bio: "With B.Com (Hons) and an MBA in Logistics, he has led the organization since 1990. Building upon his father's legacy, he has executed major PAN India projects while maintaining active social engagement as a Trustee of Sri Agarsen International Hospital.",
      tag: "CEO",
      icon: <FaChartLine />,
      color: "from-blue-500 to-green-500"
    },
    {
      name: "Dr. Uttam Singhal",
      role: "Managing Director",
      image: uttam,
      bio: "Holding B.Com (H) and MBA (Finance) degrees, he has guided the organization since 2004 with a modern approach. His leadership has established extensive vendor networks across India and achieved significant business milestones through visionary execution.",
      tag: "MD",
      icon: <FaRocket />,
      color: "from-green-500 to-blue-500"
    },
    {
      name: "Mr. Siddharth Kashyap",
      role: "Chief Financial Officer",
      image: Siddharth,
      bio: "As CFO & COO, he brings strategic financial expertise and operational efficiency to the organization. His disciplined approach to financial management supports sustainable growth while ensuring organizational effectiveness across all operations.",
      tag: "CFO",
      icon: <FaHandshake />,
      color: "from-purple-500 to-blue-500"
    }
  ];

  const visionPoints = [
    {
      icon: <FaGlobe />,
      text: "Beginning with two-wheelers, we are steadily expanding our reach across the globe.",
      color: "text-green-500"
    },
    {
      icon: <FaBrain />,
      text: "Integrate AI-driven intelligence to optimize energy usage, enhance performance, and predict system behavior.",
      color: "text-blue-500"
    },
    {
      icon: <FaRocket />,
      text: "Drive smarter and more sustainable mobility solutions that transform transportation worldwide.",
      color: "text-purple-500"
    },
    {
      icon: <FaChartLine />,
      text: "Lead the hybrid revolution by creating innovative platforms that bridge conventional and electric vehicles.",
      color: "text-teal-600"
    },
    {
      icon: <FaLightbulb />,
      text: "Pioneer advanced engineering solutions that make eco-friendly transportation accessible and practical for everyone.",
      color: "text-yellow-500"
    }
  ];

  const missionPoints = [
    {
      icon: <FaLeaf />,
      text: "Preserve our environment by reducing noise pollution and creating cleaner, healthier living conditions for all.",
      color: "text-green-500"
    },
    {
      icon: <FaCogs />,
      text: "Develop intelligent, noise-free transportation solutions through AI-enhanced hybrid electric systems for riders and communities.",
      color: "text-blue-500"
    },
    {
      icon: <FaUsers />,
      text: "Reduce conversion costs and accelerate hybrid vehicle adoption by over 70% using data-driven and AI-powered technological innovation.",
      color: "text-purple-500"
    },
    {
      icon: <FaBrain />,
      text: "Leverage artificial intelligence to optimize energy efficiency, predict performance, and enable smarter hybrid mobility solutions.",
      color: "text-teal-600"
    },
    {
      icon: <FaLightbulb />,
      text: "Design practical, AI-assisted plug-in hybrid systems with home-charging capabilities for maximum convenience and reliability.",
      color: "text-yellow-500"
    }
  ];


  return (
    <div className="w-screen bg-gradient-to-b from-gray-50 to-white overflow-hidden">
      {/* Animated Background */}
      <div className="fixed inset-0 w-full h-full overflow-hidden z-0">
        <img
          src={wave}
          className="w-full h-full object-cover opacity-10 animate-float-slow"
          alt="Background Wave Pattern"
          aria-hidden="true"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-white/20 to-white"></div>
      </div>

      {/* Hero Section */}
      <section className="relative w-full min-h-screen flex flex-col justify-center items-center px-4 sm:px-6 lg:px-8 py-12 sm:py-20 z-10">
        <div className="max-w-6xl w-full z-10 px-4 sm:px-6">
          <div className="relative">
            {/* Floating Particles */}
            <div className="absolute -top-6 -left-6 w-12 h-12 bg-green-300 rounded-full blur-xl opacity-30 animate-ping-slow"></div>
            <div className="absolute -bottom-6 -right-6 w-16 h-16 bg-blue-300 rounded-full blur-xl opacity-30 animate-pulse-slow animation-delay-1000"></div>
            <div className="absolute top-1/2 right-10 w-8 h-8 bg-purple-300 rounded-full blur-lg opacity-20 animate-bounce-slow animation-delay-500"></div>

            <div className="bg-white/95 backdrop-blur-md border border-gray-100/50 rounded-3xl shadow-2xl p-6 sm:p-8 md:p-12 text-center transition-all duration-500 animate-fade-in-up hover:shadow-3xl hover:scale-[1.01]">
              <div className="flex flex-wrap justify-center gap-3 mb-6">
                <div className="inline-flex items-center gap-3 bg-gradient-to-r from-green-500 to-green-600 text-white px-6 py-2 rounded-full animate-bounce-subtle">
                  <FaGlobe className="text-lg" />
                  <span className="font-semibold">KGV Hybrid Innovations</span>
                </div>

                {/* Premium AI Badge */}
                <div className="group transition-all duration-500 hover:scale-110 active:scale-95">
                  <div className="relative overflow-hidden bg-black/80 backdrop-blur-xl px-5 py-2 rounded-full shadow-[0_0_20px_rgba(59,130,246,0.4)] flex items-center gap-3 border border-blue-500/50">
                    <span className="absolute inset-0 w-1/2 h-full bg-gradient-to-r from-transparent via-white/20 to-transparent -rotate-45 shimmer-sweep"></span>
                    <FaBrain className="text-blue-400 animate-pulse" />
                    <span className="text-white text-[10px] sm:text-xs font-black tracking-[0.2em] uppercase">
                      AI <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-indigo-400">Core Powered</span>
                    </span>
                  </div>
                </div>
              </div>

              <h1 className="text-4xl sm:text-4xl md:text-4xl font-bold mb-6 md:mb-8 tracking-tight animate-slide-up">
                <span className="bg-gradient-to-r from-green-800 via-black-00 to-teal-900 bg-clip-text text-transparent">
                  KGV's Vision
                </span>
              </h1>

              <div className="max-w-4xl mx-auto">
                <p className="text-base sm:text-lg md:text-xl text-gray-700 leading-relaxed md:leading-loose animate-slide-up-delay">
                  At KGV, we are <span className="font-bold text-green-600 animate-pulse-slow">developing customer-oriented solutions</span> to address high transportation costs by converting conventional two-wheelers into plug-in hybrid EVs. Our vision extends beyond domestic markets as we aim to introduce our innovative products internationally. The current transportation landscape presents significant challenges for both petrol-powered and electric vehicles, each with distinct environmental, infrastructure, and usability limitations. We provide <span className="font-bold text-blue-600 animate-pulse-slow">comprehensive e-mobility solutions</span> through hybrid accessories that effectively bridge the gap between traditional and electric motorcycles, now <span className="font-bold text-indigo-600 underline decoration-indigo-300">driven by AI-optimized intelligence</span> for superior performance.
                </p>
              </div>

              {/* Animated Stats */}
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-8 max-w-2xl mx-auto">
                <div className="bg-white rounded-xl p-4 shadow-lg border border-green-100 hover:border-green-300 transition-all duration-300 animate-card-pop hover:scale-105">
                  <div className="text-2xl font-bold text-green-600">100%</div>
                  <div className="text-xs text-gray-600">Customer Focus</div>
                </div>
                <div className="bg-white rounded-xl p-4 shadow-lg border border-blue-100 hover:border-blue-300 transition-all duration-300 animate-card-pop animation-delay-100 hover:scale-105">
                  <div className="text-2xl font-bold text-blue-600">70%+</div>
                  <div className="text-xs text-gray-600">Cost Reduction</div>
                </div>
                <div className="bg-white rounded-xl p-4 shadow-lg border border-purple-100 hover:border-purple-300 transition-all duration-300 animate-card-pop animation-delay-200 hover:scale-105">
                  <div className="text-2xl font-bold text-teal-600">PAN India</div>
                  <div className="text-xs text-gray-600">Presence</div>
                </div>
                <div className="bg-white rounded-xl p-4 shadow-lg border border-yellow-100 hover:border-yellow-300 transition-all duration-300 animate-card-pop animation-delay-300 hover:scale-105">
                  <div className="text-2xl font-bold text-yellow-600">Global</div>
                  <div className="text-xs text-gray-600">Vision</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Vision & Mission Section */}
      <section className="relative max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16 z-10">
        <div className="relative bg-white/90 backdrop-blur-sm rounded-2xl shadow-2xl p-6 sm:p-8 md:p-10 overflow-hidden animate-fade-in">
          {/* Animated Background Elements */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-gradient-to-br from-green-100 to-transparent rounded-full -translate-y-32 translate-x-32 opacity-30 animate-spin-slow"></div>
          <div className="absolute bottom-0 left-0 w-64 h-64 bg-gradient-to-tr from-blue-100 to-transparent rounded-full translate-y-32 -translate-x-32 opacity-30 animate-spin-slow animation-delay-1000"></div>

          <div className="text-center mb-10 md:mb-12 relative z-10">
            <div className="inline-flex items-center gap-2 bg-gradient-to-r from-green-500 to-teal-500 text-white px-6 py-2 rounded-full mb-4 animate-bounce-subtle">
              <FaBullseye className="text-lg" />
              <span className="font-semibold">Our Core</span>
            </div>
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4 animate-slide-up">
              <span className="bg-gradient-to-r from-green-600 to-teal-600 bg-clip-text text-transparent">
                Vision & Mission
              </span>
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-green-500 to-blue-500 mx-auto rounded-full animate-width-grow"></div>
          </div>

          <div className="grid md:grid-cols-2 gap-6 sm:gap-8 relative z-10">
            {/* Vision Card */}
            <div className="relative rounded-2xl p-6 sm:p-8 shadow-xl bg-gradient-to-br from-green-50/80 to-white/80 backdrop-blur-sm border border-green-200/50 transition-all duration-500 animate-card-pop hover:shadow-2xl hover:scale-[1.02] group overflow-hidden">
              <div className="absolute inset-0 bg-gradient-to-br from-green-100/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
              <div className="flex flex-col items-center mb-5 md:mb-6 relative z-10">
                <div className="w-16 h-16 bg-gradient-to-br from-green-500 to-green-600 rounded-full flex items-center justify-center mb-4 shadow-lg group-hover:scale-110 transition-transform duration-500">
                  <FaEye className="w-8 h-8 text-white" />
                </div>
                <h3 className="text-2xl sm:text-3xl font-bold text-green-700 text-center">Vision</h3>
              </div>
              <ul className="space-y-3 sm:space-y-4 relative z-10">
                {visionPoints.map((point, index) => (
                  <li
                    key={index}
                    className="flex items-start group/item animate-slide-right"
                    style={{ animationDelay: `${index * 200}ms` }}
                  >
                    <span className={`${point.color} mr-3 mt-1 text-xl group-hover/item:scale-125 transition-transform duration-300`}>
                      {point.icon}
                    </span>
                    <span className="text-gray-700 text-base flex-1 group-hover:text-gray-800 transition-colors duration-300">
                      {point.text}
                    </span>
                  </li>
                ))}
              </ul>


            </div>

            {/* Mission Card */}
            <div className="relative rounded-2xl p-6 sm:p-8 shadow-xl bg-gradient-to-br from-blue-50/80 to-white/80 backdrop-blur-sm border border-blue-200/50 transition-all duration-500 animate-card-pop animation-delay-300 hover:shadow-2xl hover:scale-[1.02] group overflow-hidden">
              <div className="absolute inset-0 bg-gradient-to-br from-teal-100/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
              <div className="flex flex-col items-center mb-5 md:mb-6 relative z-10">
                <div className="w-16 h-16 bg-gradient-to-br from-teal-600 to-teal-900 rounded-full flex items-center justify-center mb-4 shadow-lg group-hover:scale-110 transition-transform duration-500">
                  <FaBullseye className="w-8 h-8 text-white" />
                </div>
                <h3 className="text-2xl sm:text-3xl font-bold text-teal-700 text-center">Mission</h3>
              </div>
              <ul className="space-y-3 sm:space-y-4 relative z-10">
                {missionPoints.map((point, index) => (
                  <li
                    key={index}
                    className="flex items-start group/item animate-slide-right"
                    style={{ animationDelay: `${index * 200}ms` }}
                  >
                    <span className={`${point.color} mr-3 mt-1 text-xl group-hover/item:scale-125 transition-transform duration-300`}>
                      {point.icon}
                    </span>
                    <span className="text-gray-700 text-base flex-1 group-hover:text-gray-800 transition-colors duration-300">
                      {point.text}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Intellectual Property & Innovation Section */}
      <section className="relative w-full py-20 sm:py-32 z-10 overflow-hidden bg-white">
        {/* Subtle Luxury Backdrop */}
        <div className="absolute top-0 left-0 w-full h-full opacity-[0.03] pointer-events-none">
          <div className="absolute top-0 left-1/4 w-px h-full bg-gradient-to-b from-transparent via-slate-900 to-transparent"></div>
          <div className="absolute top-0 right-1/4 w-px h-full bg-gradient-to-b from-transparent via-slate-900 to-transparent"></div>
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col lg:flex-row items-center gap-16 lg:gap-24">
            {/* Gallery Frame Column */}
            <div className="w-full lg:w-1/2 relative group">
              {/* Museum Spotlight Effect */}
              <div className="absolute -top-20 left-1/2 -translate-x-1/2 w-48 h-48 bg-amber-200/20 blur-[100px] rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-1000"></div>

              <div className="relative">
                {/* Floating Shadow */}
                <div className="absolute inset-4 bg-black/10 blur-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-700 -z-10 group-hover:translate-y-8"></div>

                {/* Frame Container */}
                <div className="bg-white p-4 sm:p-6 shadow-[0_20px_50px_rgba(0,0,0,0.05)] border border-slate-100 rounded-sm relative transition-all duration-700 group-hover:-translate-y-2">
                  {/* Internal Border (Classic Frame) */}
                  <div className="border border-slate-200 p-2 sm:p-4 bg-slate-50/50">
                    <img
                      src="/patent.jpg"
                      alt="Official Patent Certificate"
                      className="w-full h-auto grayscale-[0.2] hover:grayscale-0 transition-all duration-700"
                    />
                  </div>

                  {/* Official Plaque */}
                  <div className="mt-8 flex justify-center">
                    <div className="px-6 py-2 bg-slate-50 border border-slate-200 shadow-sm rounded-sm">
                      <div className="flex items-center gap-4">
                        <FaAward className="text-amber-600 text-xl" />
                        <div className="text-left leading-none">
                          <p className="text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-1">Authenticated by</p>
                          <p className="text-[11px] font-black text-slate-800 uppercase tracking-tight">The Patent Office, India</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Content & Schematic Column */}
            <div className="w-full lg:w-1/2 space-y-12">
              <div className="space-y-6">
                <div className="h-px w-20 bg-amber-600"></div>
                <h2 className="text-4xl sm:text-5xl font-extrabold text-slate-900 tracking-tight font-playfair">
                  Technical <br /> <span className="text-amber-600 italic">Authority.</span>
                </h2>
                <p className="text-lg text-slate-600 leading-relaxed max-w-xl">
                  Sustainability through verified excellence. Our Hybrid E-Mobility Solution is not just a concept, but a protected innovation, recognized for its unique contribution to the future of transportation.
                </p>
              </div>

              {/* Schematic Details Grid */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-10">
                {[
                  { label: "Patent Registry", value: "No. 586955", detail: "Official Grant ID" },
                  { label: "Invention Class", value: "Hybrid Mobility", detail: "Smart Tech Solution" },
                  { label: "Grant Authority", value: "Govt. of India", detail: "The Patent Office" },
                  { label: "Primary Patentee", value: "P. P. Singhal", detail: "Chief Innovation Officer" }
                ].map((item, idx) => (
                  <div key={idx} className="relative space-y-2 group/item">
                    <div className="flex items-baseline gap-4">
                      <span className="text-slate-200 font-medium text-xs font-mono">{idx + 1}.0</span>
                      <h4 className="text-xs font-bold text-slate-400 uppercase tracking-[0.2em]">{item.label}</h4>
                    </div>
                    <div className="pl-8 flex flex-col gap-1">
                      <p className="text-lg font-bold text-slate-900 tracking-tight leading-none">{item.value}</p>
                      <p className="text-[10px] font-semibold text-amber-600/80 uppercase tracking-widest">{item.detail}</p>
                    </div>
                    {/* Hover Decoration */}
                    <div className="absolute -left-2 top-0 bottom-0 w-px bg-slate-100 group-hover/item:bg-amber-600 transition-colors duration-300"></div>
                  </div>
                ))}
              </div>

              <div className="pt-10 flex items-center gap-6">
                <div className="w-12 h-12 rounded-full border border-slate-200 flex items-center justify-center text-slate-400">
                  <FaCertificate className="text-xl" />
                </div>
                <div className="h-px flex-1 bg-slate-100"></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Leadership Section */}
      <section className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16 pb-16 sm:pb-20 z-10">
        <div className="relative bg-gradient-to-br from-white/90 to-green-50/80 backdrop-blur-sm rounded-2xl shadow-2xl p-6 sm:p-8 md:p-10 overflow-hidden">
          {/* Animated Orbs */}
          <div className="absolute -top-20 -left-20 w-40 h-40 bg-gradient-to-br from-green-200 to-blue-200 rounded-full opacity-20 animate-pulse-slow"></div>
          <div className="absolute -bottom-20 -right-20 w-40 h-40 bg-gradient-to-br from-blue-200 to-purple-200 rounded-full opacity-20 animate-pulse-slow animation-delay-500"></div>

          <div className="text-center mb-10 md:mb-12 relative z-10">
            <div className="inline-flex items-center gap-2 bg-gradient-to-r from-teal-900 to-teal-500 text-white px-6 py-2 rounded-full mb-4 animate-bounce-subtle">
              <FaUsers className="text-lg" />
              <span className="font-semibold">Meet Our Leaders</span>
            </div>
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4 animate-slide-up">
              <span className="bg-gradient-to-r from-teal-600 to-teal-900 bg-clip-text text-transparent">
                Leadership Team
              </span>
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-teal-600 to-teal-900 mx-auto rounded-full animate-width-grow"></div>
            <p className="text-gray-600 text-base md:text-lg max-w-3xl mx-auto mt-4 animate-fade-in">
              Our leadership team combines decades of experience with forward-thinking innovation to drive sustainable transportation solutions.
            </p>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 relative z-10">
            {teamMembers.map((member, index) => (
              <div
                key={index}
                className="relative rounded-2xl p-5 sm:p-6 shadow-xl bg-white/90 backdrop-blur-sm border border-gray-100 transition-all duration-500 animate-team-card hover:shadow-2xl hover:scale-[1.03] group overflow-hidden"
                style={{ animationDelay: `${index * 300}ms` }}
              >
                {/* Card Background Glow */}
                <div className={`absolute inset-0 bg-gradient-to-br ${member.color} opacity-0 group-hover:opacity-10 transition-opacity duration-500`}></div>

                <div className="flex flex-col items-center mb-5 relative z-10">
                  {/* Profile Image with Animated Border */}
                  <div className="relative mb-4 group-hover:scale-105 transition-transform duration-500">
                    <div className="absolute inset-0 bg-gradient-to-r from-green-500 to-blue-500 rounded-full blur-md opacity-0 group-hover:opacity-70 transition-opacity duration-500"></div>
                    <img
                      src={member.image}
                      alt={member.name}
                      className="relative w-36 h-36 sm:w-40 sm:h-40 md:w-44 md:h-44 rounded-full object-cover shadow-xl border-4 border-white/80 group-hover:border-white transition-all duration-500"
                    />
                    {/* Role Badge */}
                    <div className="absolute bottom-2 right-2 w-12 h-12 bg-gradient-to-r from-teal-500 to-teal-900 rounded-full flex items-center justify-center border-4 border-white shadow-lg group-hover:scale-110 transition-transform duration-500">
                      <span className="text-white text-xs font-bold">{member.tag}</span>
                    </div>
                  </div>

                  {/* Name and Role */}
                  <div className="text-center mb-4">
                    <h3 className="text-green-800 font-bold text-lg md:text-xl mb-1 group-hover:text-green-600 transition-colors duration-300">
                      {member.name}
                    </h3>
                    <p className="text-green-600 text-sm md:text-base font-medium bg-green-50 px-3 py-1 rounded-full">
                      {member.role}
                    </p>
                  </div>

                  {/* Bio */}
                  <p className="text-gray-600 text-sm md:text-base leading-relaxed text-center group-hover:text-gray-800 transition-colors duration-300">
                    {member.bio}
                  </p>
                </div>

                {/* Connection Line */}
                <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-0 h-1 bg-gradient-to-r from-green-500 to-blue-500 rounded-full group-hover:w-24 transition-all duration-500"></div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CSS Animations */}
      <style jsx global>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-20px); }
        }
        
        @keyframes float-slow {
          0%, 100% { transform: translateY(0px) translateX(0px); }
          33% { transform: translateY(-10px) translateX(5px); }
          66% { transform: translateY(5px) translateX(-5px); }
        }
        
        @keyframes fade-in {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        
        @keyframes fade-in-up {
          from { 
            opacity: 0;
            transform: translateY(40px);
          }
          to { 
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        @keyframes slide-up {
          from { 
            opacity: 0;
            transform: translateY(30px);
          }
          to { 
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        @keyframes slide-right {
          from { 
            opacity: 0;
            transform: translateX(-30px);
          }
          to { 
            opacity: 1;
            transform: translateX(0);
          }
        }
        
        @keyframes pulse-slow {
          0%, 100% { opacity: 0.3; }
          50% { opacity: 0.5; }
        }
        
        @keyframes bounce-subtle {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-5px); }
        }
        
        @keyframes bounce-slow {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-15px); }
        }
        
        @keyframes spin-slow {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
        
        @keyframes ping-slow {
          75%, 100% { 
            transform: scale(1.2);
            opacity: 0;
          }
        }
        
        @keyframes badge-pop {
          0% { transform: scale(0.8); opacity: 0; }
          70% { transform: scale(1.1); }
          100% { transform: scale(1); opacity: 1; }
        }
        
        @keyframes card-pop {
          0% { 
            transform: scale(0.9) translateY(20px);
            opacity: 0;
          }
          100% { 
            transform: scale(1) translateY(0);
            opacity: 1;
          }
        }
        
        @keyframes team-card {
          0% { 
            transform: scale(0.95) translateY(30px);
            opacity: 0;
          }
          100% { 
            transform: scale(1) translateY(0);
            opacity: 1;
          }
        }
        
        @keyframes value-card {
          0% { 
            transform: scale(0.8);
            opacity: 0;
          }
          100% { 
            transform: scale(1);
            opacity: 1;
          }
        }
        
        @keyframes width-grow {
          from { width: 0; }
          to { width: 96px; }
        }

        /* Animation Classes */
        .animate-float { animation: float 6s ease-in-out infinite; }
        .animate-float-slow { animation: float-slow 20s ease-in-out infinite; }
        .animate-fade-in { animation: fade-in 1s ease-out forwards; }
        .animate-fade-in-up { animation: fade-in-up 1s ease-out forwards; }
        .animate-slide-up { animation: slide-up 0.8s ease-out forwards; }
        .animate-slide-up-delay { animation: slide-up 0.8s ease-out 0.3s forwards; }
        .animate-slide-right { animation: slide-right 0.8s ease-out forwards; }
        .animate-pulse-slow { animation: pulse-slow 3s ease-in-out infinite; }
        .animate-bounce-subtle { animation: bounce-subtle 2s ease-in-out infinite; }
        .animate-bounce-slow { animation: bounce-slow 4s ease-in-out infinite; }
        .animate-spin-slow { animation: spin-slow 20s linear infinite; }
        .animate-ping-slow { animation: ping-slow 3s cubic-bezier(0, 0, 0.2, 1) infinite; }
        .animate-badge-pop { animation: badge-pop 0.5s ease-out forwards; }
        .animate-card-pop { animation: card-pop 0.6s ease-out forwards; }
        .animate-team-card { animation: team-card 0.8s ease-out forwards; }
        .animate-value-card { animation: value-card 0.5s ease-out forwards; }
        .animate-width-grow { animation: width-grow 1s ease-out forwards; }

        @keyframes shimmerSweep {
          0% { transform: translateX(-100%); }
          50% { transform: translateX(100%); }
          100% { transform: translateX(100%); }
        }
        .shimmer-sweep {
          animation: shimmerSweep 3s infinite linear;
        }

        /* Animation Delays */
        .animation-delay-100 { animation-delay: 100ms; }
        .animation-delay-200 { animation-delay: 200ms; }
        .animation-delay-300 { animation-delay: 300ms; }
        .animation-delay-400 { animation-delay: 400ms; }
        .animation-delay-500 { animation-delay: 500ms; }
        .animation-delay-1000 { animation-delay: 1000ms; }
      `}</style>
    </div>
  );
};